import React from 'react'
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import { Avatar } from 'antd';
import TextEvents from './TextEvents';
import Divider from '@material-ui/core/Divider';



export default function EmployeeCard(props) {
    return (
        <div>
        <Grid
            container
            direction="row"
            justify="center"
            alignItems="center"
            className={props.classes.containerEmployeeCard}
            >
                <Paper className={props.classes.rootEmployeeCard}>
                    <Grid item xs={6}>
                        <div className={props.classes.avatarRoot}>
                            <Avatar size={100} src={props.data.avatar} icon="user" />
                        </div>
                    </Grid>
                    <Grid item xs={12} className={props.classes.gridItem}>
                        <Grid xs={12} item className={props.classes.gridSeparatorTop}>
                            Evaluado
                                    <TextEvents
                                        text={props.data.employeeName}
                                        color='darker'
                                        size='label'
                                        weight='bold'
                                    />
                        </Grid>
                        <Divider/>
                        <Divider/>
                        <Grid xs={12} item className={props.classes.gridSeparatorTop}>
                        Ficha
                                <TextEvents
                                    text={props.data.employeeId}
                                    color='darker'
                                    size='label'
                                    weight='bold'
                                />
                        </Grid>
                        <Divider/>
                        <Grid xs={12} item className={props.classes.gridSeparatorTop}>
                        Categoría
                                <TextEvents
                                    text={props.data.categoryName}
                                    color='darker'
                                    size='label'
                                    weight='bold'
                                />
                        </Grid>
                        <Divider/>
                        <Grid xs={12} item className={props.classes.gridSeparatorTop}>
                            Estatus
                                    {props.result ? <TextEvents
                                        text={ 'Aprobado'}
                                        color='green'
                                        size='label'
                                        weight='bold'
                                    />:
                                    <TextEvents
                                        text={'No aprobado'}
                                        color='warn'
                                        size='label'
                                        weight='bold'
                                    />}
                            </Grid>
                            <Divider/>                        
                    </Grid>
                </Paper>
            </Grid>
        </div>)
}